<!-- <template>
  <div class="modal fade" id="successMsgModal" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="card text-center">
            <img src="../../../public/static/images/icons/checkbox.svg" class="success_logo" />
            <div class="card-title">
              <p class="verification-text">{{ $t('verificationAccountMessage')}}</p>
            </div>
            <div class="row">
              <div class="col-lg-12 card-text">
                <p class="success-message">{{ $t('verificationMessage')}} <span class="link" @click="goToVerificationLinkPage($event)">{{ $t('needNewLink')}}</span></p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 ok-btn">
                <button class="btn btn-block emergo-blue-button" @click="redirectToLogin()">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import EventBus from '../../utils/event-bus';

export default {
  props: ['successMessage'],
  methods: {
    redirectToLogin() {
      this.$router.push({
        name: 'login',
        params: { successMessage: this.successMessage },
      });
    },
    goToVerificationLinkPage(event) {
      event.preventDefault();
      if (this.$route.path !== '/verificationlink') {
        this.$router.push('/verificationlink');
      } else {
        this.$emit('clearData');
        $('#successMsgModal').modal('hide');
      }
      // this.$emit('selectedLanguage', this.$i18n.locale);
      EventBus.$emit('languageChanged', this.$i18n.locale);
    },
  },
};
</script>
<style scoped>
.link {
  color: #00518a;
  cursor: pointer;
}
.modal .modal-dialog .modal-content {
  border-radius: 10px;
}
.modal .modal-dialog .modal-content .modal-header {
  background: #fff;
  border-radius: 10px;
  padding-top: 40px;
  padding-bottom: 40px;
}
img.success_logo{
  width: 50px;
  height: 50px;
  background-color: #4c9e45;
  border-radius: 50%;
  padding: 10px;
  margin-top: 5px;
}
.success-message {
  padding: 10px 120px 20px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  font-weight: 400;
}
.ok-btn {
  width: 27%;
  margin: auto;
  float: initial;
}
.ok-btn a {
  color: #fff;
}
p.verification-text {
  font-size: 25px;
  padding: 20px 70px 10px;
  color: #0b3c61;
  font-weight: 500;
  line-height: 28px;
}
</style> -->
<template>
  <div id="successMsgModal" class="modal fade" role="dialog">
    <div class="modal-dialog profile-confirm-poup">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header confirmpopup-bgcolor p-0">
          <div class="add-record-title">
            <div>{{ $t('verificationLink')}}</div>
            <div @click="closeModal()" class="close-icon cursor-pointer">
              <img src="/static/images/icons/ul_close_icon.svg" class="address-images" />
            </div>
          </div>
        </div>

        <div class="modal-body confirm-body">
          <div class="cancel-message">{{ $t('verificationAccountMessage')}}</div>
          <div class="verification-message">{{ $t('verificationMessage')}}</div>

          <div class="proceed-title pb-23 cursor-pointer" @click="goToVerificationLinkPage($event)" >
            {{ $t('needNewLink') }}
          </div>

        </div>

        <div class="modal-footer confirmpopup-bgcolor col-xs-12 col-sm-12 d-flex-sm-end">
          <div class="">
            <button type="button" class="btn btn-block proceed-changes" @click="redirectToLogin()">{{ $t('okButton') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import EventBus from '../../utils/event-bus';

export default {
  props: ['successMessage'],
  methods: {
    redirectToLogin() {
      $('#successMsgModal').modal('hide');
      this.$router.push({
        name: 'login',
        params: { successMessage: this.successMessage },
      });
    },
    goToVerificationLinkPage(event) {
      event.preventDefault();
      if (this.$route.path !== '/verificationlink') {
        this.$router.push('/verificationlink');
      } else {
        this.$emit('clearData');
        $('#successMsgModal').modal('hide');
      }
      // this.$emit('selectedLanguage', this.$i18n.locale);
      EventBus.$emit('languageChanged', this.$i18n.locale);
    },
    closeModal() {
      $('#successMsgModal').modal('hide');
    },
  },
};
</script>

<style scoped>
.cancel-message {
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  color: #1A1A1A;

}
.verification-message{
  color: #1A1A1A;
  font-size: 16px;
  font-family: Open Sans;
  font-weight: 700;
  padding-top: 10px;
}
label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 0px !important;
    /* font-weight: 700; */
}
.modal-header {
    background-color: #ffffff !important;
    border-bottom: 1px solid #d3d3d3 !important;
    border-top-right-radius: 6px!important;
    border-top-left-radius: 6px!important;
}

.modal-header .close {
    background: unset;
    opacity: 1;
    line-height: unset;
    width: unset;
    border-radius: unset;
    color: unset;
    background-color: #ffffff !important;
}

.add-record-title {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    color: #1A1A1A;
    padding: 17px 0px 17px 16px;
}
.close-icon {
    padding-right: 16px;
}

.proceed-title {
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #01518A;
    padding-top:10px
}

.modal-body {
    padding: 16px 17px 0px 24px;
}

.market-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: #3e3e3e;
}

label>input[type="radio"] {
    display: none;
}

label>input[type="radio"]+*::before {
    content: "";
    display: inline-block;
    vertical-align: bottom;
    width: 18px;
    height: 18px;
    margin-right: 11px;
    margin-bottom: 4px;
    border-radius: 50%;
    border-style: solid;
    border-width: 1px;
    border-color: #00518a;
    border: 2px solid #4d4d4d;
}

label>input[type="radio"]:checked+*::before {
    background: radial-gradient(#00518a 0%, #00518a 46%, transparent 51%, transparent);
    border-color: #00518a;
    border: 2px solid #00518a;
}

.proceed-changes,
.proceed-changes:hover {
    background-color: #01518a;
    height: 44px;
    min-width: 58px;
    color: #ffffff !important;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    line-height: 25px;
    float: right;
    cursor: pointer;
    padding: 6px 16px;
    /* text-transform: capitalize; */
}

.cancel-changes,
.cancel-changes:hover {
    background-color: #e6e6e6;
    height: 44px;
    min-width: 171px;
    color: #404040 !important;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    line-height: 24px;
    float: right;
    cursor: pointer;
    padding: 6px 16px;
}

.modal-footer {
    background-color: #fafaf9 !important;
    padding-right: 0px;
    border: none !important;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
}
.modal-content {
 border: none;
 border-top-right-radius: 6px!important;
 border-top-left-radius: 6px!important;
 border-bottom-right-radius: 0!important;
 border-bottom-left-radius: 0!important;
}

.pb-23 {
 padding-bottom: 44px;
}
.pb-21 {
 padding-bottom: 21px;
}
.radio-buttons {
 padding-left: 19px;
 padding-bottom: 27px;
}

@media (min-width: 768px) {
.modal-dialog {
 width: 500px;
 margin: 30px auto;
}
}
</style>
